module.exports = __webpack_public_path__ + "img/gs.f00bb48.svg";